<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BSidebar
      id="sbRsmOfficerEventFilters"
      backdrop-variant="dark"
      backdrop
      shadow
      right
    >
      <template #title>
        <i class="fad fa-filter-list" /> Filters
      </template>
      <BContainer>
        <BRow>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Month"
              label-for="filterMonth"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <flat-pickr
                id="filterMonth"
                v-model="gridEvents.filter.month"
                class="form-control"
                placeholder="--------- ----"
                :config="flatPickerConfig"
              />
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Area"
              label-for="filterArea"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="gridEvents.selected.area"
                placeholder="filter area here"
                input-id="filterArea"
                label="area_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(gridEvents.options.areas)"
                :loading="(gridEvents.fetching.areas)"
                :disabled="(gridEvents.busy || gridEvents.fetching.areas)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterAreas"
              >
                <template #no-options="">
                  no available area
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Cluster"
              label-for="filterCluster"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="gridEvents.selected.cluster"
                placeholder="filter cluster here"
                input-id="filterCluster"
                label="cluster_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(gridEvents.options.clusters)"
                :loading="(gridEvents.fetching.clusters)"
                :disabled="(gridEvents.busy || gridEvents.fetching.clusters)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterClusters"
              >
                <template #no-options="">
                  no available cluster
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Officer"
              label-for="filterOfficer"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="gridEvents.selected.fsOfficer"
                placeholder="filter officer here"
                input-id="filterOfficer"
                label="officer_name"
                clearable
                append-to-body
                :options="(gridEvents.options.fsOfficers)"
                :loading="(gridEvents.fetching.fsOfficers)"
                :disabled="(gridEvents.busy || gridEvents.fetching.fsOfficers)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterFSOfficers"
              >
                <template #option="{ officer_name, mobile_number, photos }">
                  <div class="d-flex flex-column flex-md-row py-1">
                    <div class="flex-grow-1 d-flex align-items-center">
                      <div class="mr-2">
                        <BAvatar
                          v-if="photos && photos.length > 0"
                          :src="getCustomerProfile(photos)"
                          variant="primary"
                          size="28px"
                        />
                        <BAvatar
                          v-else
                          :text="String(officer_name).charAt(0)"
                          variant="primary"
                          size="28px"
                        />
                      </div>
                      <div class="d-flex flex-column">
                        <div
                          class="text-break text-wrap"
                          v-text="officer_name"
                        />
                        <strong>{{ mobile_number || '' }}</strong>
                      </div>
                    </div>
                  </div>
                </template>
                <template #selected-option="{ officer_name, photos }">
                  <div class="d-flex flex-column flex-md-row">
                    <div class="flex-grow-1 d-flex align-items-center">
                      <div class="mr-2">
                        <BAvatar
                          v-if="photos && photos.length > 0"
                          :src="getCustomerProfile(photos)"
                          variant="primary"
                          size="28px"
                        />
                        <BAvatar
                          v-else
                          :text="String(officer_name).charAt(0)"
                          variant="primary"
                          size="28px"
                        />
                      </div>
                      <div
                        class="text-break text-wrap"
                        v-text="officer_name"
                      />
                    </div>
                  </div>
                </template>
                <template #no-options="">
                  no available officer
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
          <BCol
            cols="12"
          >
            <BFormGroup
              label="Activity"
              label-for="filterActivity"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <VSelect
                v-model="gridEvents.selected.activity"
                placeholder="filter activity here"
                input-id="filterActivity"
                label="activity_name"
                class="border border-light rounded-lg"
                clearable
                append-to-body
                :options="(gridEvents.options.activities)"
                :loading="(gridEvents.fetching.activities)"
                :disabled="(gridEvents.busy || gridEvents.fetching.activities)"
                :calculate-position="calculateDropPosition"
                @search="searchFilterActivities"
              >
                <template #no-options="">
                  no available activity
                </template>
              </VSelect>
            </BFormGroup>
          </BCol>
        </BRow>
      </BContainer>
    </BSidebar>

    <BRow
      class="py-2 mb-3"
    >
      <BCol
        cols="12"
      >
        <BFormGroup
          label="Search"
          label-for="filterSearch"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <BInputGroup>
            <BFormInput
              id="filterSearch"
              v-model="gridEvents.filter.search"
              placeholder="search here"
              autocomplete="off"
              debounce="1000"
              type="text"
            />
            <BInputGroupAppend>
              <BButton
                v-b-toggle.sbRsmOfficerEventFilters
                variant="primary"
              >
                <i
                  v-if="[settingFilters, gridEvents.fetching.clusters, gridEvents.fetching.fsOfficers, gridEvents.fetching.activities].some(trueOrFalse => trueOrFalse)"
                  class="fad fa-spinner fa-spin p-0"
                />
                <i
                  v-else
                  class="fad fa-filter-list"
                /> Filters
              </BButton>
            </BInputGroupAppend>
          </BInputGroup>
        </BFormGroup>
      </BCol>
    </BRow>

    <BRow
      v-if="gridEvents.busy"
      class="gap-y-6 mb-3"
    >
      <BCol
        cols="12"
      >
        <div class="text-center py-5">
          <BIcon
            icon="stopwatch"
            font-scale="5"
            animation="cylon"
          />
          <p class="h3 py-2">
            <strong>Loading . . .</strong>
          </p>
        </div>
      </BCol>
    </BRow>

    <BRow
      v-else-if="Number(gridEvents.rows.length) <= 0 && !gridEvents.busy"
    >
      <BCol
        cols="12"
        class="text-center py-5"
      >
        <BIcon
          icon="calendar"
          font-scale="5"
        />
        <p class="h3 py-2">
          <strong>No events found</strong>
        </p>
      </BCol>
    </BRow>

    <BRow
      v-else
      class="gap-y-6 mb-3"
    >
      <BCol
        v-for="(event, index) in gridEvents.rows"
        :key="index"
        cols="12"
        lg="6"
      >
        <Event
          :details="{
            id: event.id,
            activity_name: event?.task?.activity?.activity_name || '',
            province_name: event?.province?.province_name || '',
            municipality_name: event?.municipality?.municipality_name || '',
            barangay_name: event?.barangay?.barangay_name || '',
            customer_name: event?.customer ? `${event.customer?.first_name || ''} ${event.customer?.last_name || ''}` : '',
            remarks: event.remarks,
            created_at: event.created_at
          }"
          :officer="{
            id: event?.task?.assignee?.id || '',
            photo_url: event?.task?.assignee?.photo_url || '',
            first_name: event?.task?.assignee?.first_name || '',
            last_name: event?.task?.assignee?.last_name || '',
          }"
          :attachment-path="event.attachment_path || ''"
          :attachments="event.attachments || []"
          :loading="gridEvents.busy"
          @show:attachment="attachmentIndex => openPictures(event, attachmentIndex)"
          @more:attachments="() => viewEvent(event, true)"
        >
          <template #footer>
            <div class="d-flex align-items-center justify-content-end mt-2">
              <div class="d-flex gap-2">
                <BButton
                  size="sm"
                  variant="warning"
                  @click.prevent="viewEvent(event)"
                >
                  View
                </BButton>
              </div>
            </div>
          </template>
        </Event>
      </BCol>
    </BRow>

    <BRow>
      <BCol
        cols="12"
        md="6"
        class="mt-1 mb-md-0 mb-2"
      >
        <BSelect
          v-model="gridEvents.perPage"
          :options="gridEvents.pageOptions"
          :disabled="gridEvents.busy"
          class="w-100 w-md-75px"
          size="sm"
        />
      </BCol>

      <BCol
        cols="12"
        md="6"
        class="d-flex justify-content-center justify-content-md-end mt-1"
      >
        <BPagination
          v-if="gridEvents.currentPage"
          v-model="gridEvents.currentPage"
          :total-rows="gridEvents.totalRows"
          :per-page="gridEvents.perPage"
          :disabled="gridEvents.busy"
          class="mb-0"
          aria-controls="table"
          prev-text="Prev"
          next-text="Next"
          first-number
          last-number
          pills
        />
      </BCol>
    </BRow>

    <BModal
      ref="modalCreateEvent"
      size="lg"
      title="Task"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
      @shown="eventModalShown"
      @hidden="eventModalHidden"
    >
      <BTabs
        v-model="state.modalEventTab"
        active-nav-item-class="font-weight-bold text-primary"
        nav-class="scrollable-x-tabs no-scrollbar nav-event-tabs gap-x-1"
        content-class="scrollable"
        pills
      >
        <template #tabs-start>
          <div class="nav-item">
            <div
              class="d-flex align-items-center position-absolute"
              style="padding: 2px 1px; height: 38px;"
            >
              <i
                class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
                style="font-size: 20px;"
              />
            </div>
          </div>
        </template>
        <template #tabs-end>
          <div class="nav-item">
            <div
              class="d-flex align-items-center position-absolute"
              style="right: 20px; padding: 2px 1px; height: 38px;"
            >
              <i
                class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
                style="font-size: 20px;"
              />
            </div>
          </div>
        </template>
        <BTab
          class="p-2 min-h-400px"
        >
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-xl fad fa-file-lines" />
              <b class="is-tab-active ml-1">
                Details
              </b>
            </div>
          </template>

          <ValidationObserver
            ref="formEvent"
          >
            <form
              role="form"
              novalidate
              @submit.prevent
            >
              <BRow>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="activity_id"
                    name="activity"
                    rules="required"
                  >
                    <BFormGroup
                      label="Activity"
                      label-for="fActivityName"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fActivityName"
                        v-model="formEvent.activity_name"
                        type="text"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="event_date"
                    name="date"
                    rules="required"
                  >
                    <BFormGroup
                      label="Event Date"
                      label-for="fEventDate"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fEventDate"
                        v-model="formEvent.event_date"
                        type="date"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="customer_id"
                    name="customer"
                    rules="required"
                  >
                    <BFormGroup
                      label="Customer"
                      label-for="fCustomer"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fCustomer"
                        v-model="formEvent.customer_name"
                        type="text"
                        placeholder="no selected customer"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="province_id"
                    name="province"
                    rules="required"
                  >
                    <BFormGroup
                      label="Province"
                      label-for="fProvince"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fProvince"
                        v-model="formEvent.province_name"
                        type="text"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="municipality_id"
                    name="municipaliy"
                    rules="required"
                  >
                    <BFormGroup
                      label="Municipality"
                      label-for="fMunicipality"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fMunicipality"
                        v-model="formEvent.municipality_name"
                        type="text"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="barangay_id"
                    name="barangay"
                    rules="required"
                  >
                    <BFormGroup
                      label="Barangay"
                      label-for="fBarangay"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fBarangay"
                        v-model="formEvent.barangay_name"
                        type="text"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="actual_hectares"
                    name="actual hectares"
                    rules="required"
                  >
                    <BFormGroup
                      label="Actual Hectares"
                      label-for="fActualHectares"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fActualHectares"
                        v-model="formEvent.actual_hectares"
                        type="number"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="customer_attended"
                    name="number of attendees"
                    rules="required"
                  >
                    <BFormGroup
                      :label="`No. of Actual Attendees ( Min ${formEvent.customer_per_event} per Event )`"
                      label-for="fCustomerAttended"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fCustomerAttended"
                        v-model="formEvent.customer_attended"
                        type="number"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="actual_costs"
                    name="actual cost"
                    rules="required|currency:0"
                  >
                    <BFormGroup
                      label="Actual Cost ( Event Expenses ) ( Php )"
                      label-for="fActualCost"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fActualCost"
                        v-model="maskedEvent.actual_costs"
                        v-mask="currencyMask"
                        type="text"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="customer_bought"
                    name="number of buyers"
                    rules="required"
                  >
                    <BFormGroup
                      label="No. of Buyers"
                      label-for="fCustomerBought"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fCustomerBought"
                        v-model="formEvent.customer_bought"
                        type="number"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="actual_sales"
                    name="actual sales"
                    rules="required|currency:0"
                  >
                    <BFormGroup
                      label="Actual Sales ( Sold to Buyers ) ( Php )"
                      label-for="fActualSales"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fActualSales"
                        v-model="maskedEvent.actual_sales"
                        v-mask="currencyMask"
                        type="text"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="customer_bookings"
                    name="customer bookings"
                    rules="required"
                  >
                    <BFormGroup
                      label="No. of Sales Order Bookings"
                      label-for="fCustomerBookings"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fCustomerBookings"
                        v-model="formEvent.customer_bookings"
                        type="number"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol
                  cols="12"
                  md="6"
                >
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="booking_sales"
                    name="booking sales"
                    rules="required|currency:0"
                  >
                    <BFormGroup
                      label="Booking Sales ( Sales Orders ) ( Php )"
                      label-for="fBookingSales"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <BFormInput
                        id="fBookingSales"
                        v-model="maskedEvent.booking_sales"
                        v-mask="currencyMask"
                        type="text"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>

                <BCol cols="12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    vid="remarks"
                    name="remarks"
                    rules="required|max:1000"
                  >
                    <BFormGroup
                      label="Remarks"
                      label-for="fRemarks"
                      label-class="font-weight-bolder"
                      class="mb-2"
                    >
                      <template #label>
                        <span class="d-flex justify-content-between">
                          Remarks
                          <span>
                            {{ formEvent.remarks ? formEvent.remarks.length : 0 }} / 1000
                          </span>
                        </span>
                      </template>
                      <BFormTextarea
                        id="fRemarks"
                        v-model="formEvent.remarks"
                        placeholder="enter remarks here"
                        rows="7"
                        max-rows="9999"
                        disabled
                      />
                      <div
                        v-if="(errors.length > 0)"
                        class="invalid-feedback"
                        v-text="errors[0]"
                      />
                    </BFormGroup>
                  </ValidationProvider>
                </BCol>
              </BRow>
            </form>
          </ValidationObserver>
        </BTab>
        <!-- <BTab
          class="p-2 min-h-400px"
        >
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-xl fad fa-file-invoice-dollar" />
              <b class="is-tab-active ml-1">
                Sold Products
              </b>
            </div>
          </template>

          <Products
            ref="tableProducts"
            :products="formEvent.products"
            :use-form="!state.editing"
          />
        </BTab> -->
        <BTab
          class="p-2 min-h-400px"
        >
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-xl fad fa-paperclip" />
              <b class="is-tab-active ml-1">
                Attachments
              </b>
            </div>
          </template>
          <Attachment
            ref="attachmentUploader"
            :path="formEvent.attachment_path"
            :files="formEvent.attachments"
            :loading="state.busy"
            :show-uploader="!state.editing"
          />
        </BTab>
        <!-- <BTab>
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-xl fad fa-map-marker-alt" />
              <b class="is-tab-active ml-1">
                Location
              </b>
            </div>
          </template>
          <div class="d-flex align-items-center justify-center p-3">
            <div
              id="mapLibre"
              style="width: 100%; height: calc(100vh - 240px);"
            />
          </div>
        </BTab> -->
      </BTabs>
      <template #modal-footer="{ cancel }">
        <div class="w-100 d-flex justify-content-end align-items-center gap-2">
          <BButton

            variant="outline-dark"
            :disabled="state.busy"
            @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
          >
            {{ state.editing ? 'Close' : 'Discard' }}
          </BButton>
        </div>
      </template>
    </BModal>

    <Preview
      ref="modalPreview"
    />

  </BContainer>
</template>
<script>
import QUERY from 'lodash'
import { mapGetters } from 'vuex'
import { Map, Marker } from 'maplibre-gl'
import MOMENT from 'moment'
import FPMonthSelect from 'flatpickr/dist/plugins/monthSelect'
import { setTableOptions, getTableOptions } from '@/forage/audit/officers/events'

import Event from '@/views/audit/officer-events/components/Event.vue'
import Attachment from '@/views/audit/officer-events/components/Attachment.vue'
import Preview from '@/views/audit/officer-other-events/components/Preview.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MProvinces from '@/mixins/locations/provinces'
import MMunicipalities from '@/mixins/locations/municipalities'
import MBarangays from '@/mixins/locations/barangays'
import MAreas from '@/mixins/locations/areas'
import MClusters from '@/mixins/locations/clusters'
import MCrops from '@/mixins/maintenances/crops'
import MActivities from '@/mixins/maintenances/activities'
import MFSOfficers from '@/mixins/accounts/fsos'
import MCustomers from '@/mixins/accounts/customers'

import { SAuditOfficerTaskEvent } from '@/services/audit'

// import Products from '@/views/audit/officer-task-events/components/Products.vue'

export default {
  name: 'VAuditOfficerTaskEvents',

  components: {
    Event,
    // Products,
    Attachment,
    Preview
  },

  mixins: [
    MxMisc,
    MxFormatter,
    MxImageUrl,
    MProvinces,
    MMunicipalities,
    MBarangays,
    MAreas,
    MClusters,
    MCrops,
    MActivities,
    MFSOfficers,
    MCustomers
  ],

  beforeRouteEnter (_to, _from, navigate) {
    getTableOptions().then(options => {
      navigate(context => {
        if (context.currentUser) {
          context.state.settings = true

          if (options) {
            const { currentPage, perPage, sortBy, sortDesc, totalRows, filter } = options

            context.gridEvents = Object.assign(context.gridEvents, {
              totalRows: totalRows,
              sortBy: sortBy,
              sortDesc: sortDesc,
              perPage: perPage,
              currentPage: currentPage,
              filter: {
                search: filter.search,
                month: filter.month,
                area: '',
                cluster: '',
                officer: '',
                activity: ''
              },
              editable: {
                area: filter.area,
                cluster: filter.cluster,
                fsOfficer: filter.officer,
                activity: filter.activity
              }
            })
          } else {
            context.gridEvents.currentPage = 1
          }

          context.$nextTick(() => {
            context.getAreas(context.gridEvents).finally(() => {
              if (context.gridEvents.editable.area) {
                context.gridEvents.selected.area = QUERY.find(context.gridEvents.options.areas, {
                  id: context.gridEvents.editable.area
                }) || ''
              }

              context.getClusters(context.gridEvents, '', context.gridEvents.editable.area).finally(() => {
                if (context.gridEvents.editable.cluster) {
                  context.gridEvents.selected.cluster = QUERY.find(context.gridEvents.options.clusters, {
                    id: context.gridEvents.editable.cluster
                  }) || ''
                }

                context.getFSOfficers(context.gridEvents, '', context.gridEvents.editable.area, context.gridEvents.editable.cluster).finally(() => {
                  if (context.gridEvents.editable.fsOfficer) {
                    context.gridEvents.selected.fsOfficer = QUERY.find(context.gridEvents.options.fsOfficers, {
                      id: context.gridEvents.editable.fsOfficer
                    }) || ''

                    context.gridEvents.editable.fsOfficer = ''
                  }

                  context.gridEvents.editable.cluster = ''
                  context.gridEvents.editable.area = ''

                  context.getActivities(context.gridEvents).finally(() => {
                    if (context.gridEvents.editable.activity) {
                      context.gridEvents.selected.activity = QUERY.find(context.gridEvents.options.activities, {
                        id: context.gridEvents.editable.activity
                      }) || ''

                      context.gridEvents.editable.activity = ''
                    }

                    context.state.settings = false
                    context.gridProvider()
                  })
                })
              })
            })
          })
        }
      })
    })
  },

  middleware: [
    'auth',
    'audit'
  ],

  metaInfo: () => ({
    title: 'Officer Events'
  }),

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        plugins: [
          new FPMonthSelect({
            dateFormat: 'Y-m',
            altFormat: 'F Y'
          })
        ]
      },
      state: {
        busy: false,
        editing: false,
        settings: false,
        modalEventTab: 0
      },
      maskedEvent: {
        actual_costs: '',
        actual_sales: '',
        booking_sales: ''
      },
      formEventValidation: {
        eventDate: {
          min: MOMENT().startOf('month').format('YYYY-MM-DD'),
          max: MOMENT().endOf('month').format('YYYY-MM-DD')
        }
      },
      formEvent: {
        id: '',
        activity_id: '',
        activity_name: '',
        customer_per_event: '',
        task_id: '',
        event_date: '',
        customer_id: '',
        customer_name: '',
        province_id: '',
        province_name: '',
        municipality_id: '',
        municipality_name: '',
        barangay_id: '',
        barangay_name: '',
        actual_hectares: '',
        crop_id: '',
        crop_name: '',
        customer_attended: '',
        customer_bought: '',
        customer_bookings: '',
        conversion_rate: '',
        actual_costs: '',
        actual_sales: '',
        booking_sales: '',
        remarks: '',
        attachment_path: '',
        attachments: [],
        products: [],
        geolocation: {
          longitude: 0,
          latitude: 0
        },
        active: 1
      },
      gridEvents: {
        busy: false,
        fetching: {
          areas: false,
          clusters: false,
          fsOfficers: false,
          activities: false
        },
        options: {
          areas: [],
          clusters: [],
          fsOfficers: [],
          activities: []
        },
        selected: {
          area: '',
          cluster: '',
          fsOfficer: '',
          activityType: 'Event',
          activity: ''
        },
        editable: {
          area: '',
          cluster: '',
          fsOfficer: '',
          activity: ''
        },
        filter: {
          search: '',
          area: '',
          cluster: '',
          officer: '',
          activity: '',
          month: MOMENT().format('YYYY-MM')
        },
        filterOn: [],
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        rows: []
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    settingFilters () {
      const hasEditables = Object.keys(this.gridEvents.editable).map(
        editableKey => this.gridEvents.editable[editableKey]
      ).some(val => String(val) !== '')

      return hasEditables
    }
  },

  watch: {
    'maskedEvent.actual_costs' (actualCost) {
      if (actualCost) {
        this.formEvent.actual_costs = actualCost.replace(/[^\d.]/g, '')
        return
      }

      this.formEvent.actual_costs = actualCost
    },

    'maskedEvent.actual_sales' (actualSales) {
      if (actualSales) {
        this.formEvent.actual_sales = actualSales.replace(/[^\d.]/g, '')
        return
      }

      this.formEvent.actual_sales = actualSales
    },

    'formEvent.customer_attended' () {
      this.formEvent.conversion_rate = parseFloat(
        (this.formEvent.customer_bought / this.formEvent.customer_attended) * 100
      ).toFixed(2)
    },

    'formEvent.customer_bought' () {
      this.formEvent.conversion_rate = parseFloat(
        (this.formEvent.customer_bought / this.formEvent.customer_attended) * 100
      ).toFixed(2)
    },

    'gridEvents.selected.area' (area) {
      this.gridEvents.filter.area = area?.id || ''
    },

    'gridEvents.selected.cluster' (cluster) {
      this.gridEvents.filter.cluster = cluster?.id || ''
    },

    'gridEvents.selected.fsOfficer' (fsOfficer) {
      this.gridEvents.filter.officer = fsOfficer?.id || ''
    },

    'gridEvents.selected.activity' (activity) {
      this.gridEvents.filter.activity = activity?.id || ''
    },

    'gridEvents.filter': {
      handler () {
        if (!this.state.settings) {
          this.gridProvider()
        }
      },
      deep: true
    },

    'gridEvents.filter.area' (area) {
      if (!this.state.settings) {
        this.getClusters(this.gridEvents, '', area)
        this.getFSOfficers(this.gridEvents, '', area)
      }
    },

    'gridEvents.filter.cluster' (cluster) {
      if (!this.state.settings) {
        this.getFSOfficers(this.gridEvents, '', this.gridEvents.filter.area, cluster)
      }
    },

    'gridEvents.currentPage' () {
      if (!this.state.settings) {
        this.gridProvider()
      }
    },

    'gridEvents.perPage' () {
      if (!this.state.settings) {
        this.gridProvider()
      }
    }
  },

  methods: {

    async gridProvider () {
      this.gridEvents.busy = true

      const payload = {
        page: this.gridEvents.currentPage,
        per_page: this.gridEvents.perPage,
        sort: this.gridEvents.sortBy,
        sort_desc: this.gridEvents.sortDesc,
        filter_text: this.gridEvents.filter.search,
        assignee_id: this.gridEvents.filter.officer,
        area_id: this.gridEvents.filter.area,
        cluster_id: this.gridEvents.filter.cluster,
        activity_id: this.gridEvents.filter.activity,
        schedule: this.gridEvents.filter.month
      }

      return SAuditOfficerTaskEvent.get(payload).then(
        ({ data }) => {
          this.gridEvents.totalRows = data.total_rows
          this.gridEvents.rows = data.items

          setTableOptions({
            currentPage: this.gridEvents.currentPage,
            perPage: this.gridEvents.perPage,
            sortBy: this.gridEvents.sortBy,
            sortDesc: this.gridEvents.sortDesc,
            totalRows: data.total_rows,
            filter: this.gridEvents.filter
          })

          return data.items
        }
      ).catch(() => {
        this.gridEvents.totalRows = 0
        this.gridEvents.rows = []

        setTableOptions({
          currentPage: this.gridEvents.currentPage,
          perPage: this.gridEvents.perPage,
          sortBy: this.gridEvents.sortBy,
          sortDesc: this.gridEvents.sortDesc,
          totalRows: 0,
          filter: this.gridEvents.filter
        })
        return []
      }).finally(() => {
        this.gridEvents.busy = false
      })
    },

    async searchFilterAreas (search, loading) {
      this.searchAreasProvider(this.gridEvents, search, loading)
    },

    async searchFilterClusters (search, loading) {
      this.searchClustersProvider(this.gridEvents, search, loading)
    },

    async searchFilterFSOfficers (search, loading) {
      this.searchFSOfficersProvider(this.gridEvents, search, loading)
    },

    async searchFilterActivities (search, loading) {
      this.searchActivitiesProvider(this.gridEvents, search, loading)
    },

    openPictures (activity, index) {
      this.$refs.modalPreview.show(activity.attachments, activity.attachment_path, index)
    },

    viewEvent (event, goToAttachments = false) {
      this.state.editing = true

      this.maskedEvent = Object.assign(this.maskedEvent, {
        actual_costs: event.actual_costs || '',
        actual_sales: event.actual_sales || '',
        booking_sales: event.booking_sales || ''
      })

      this.formEvent = Object.assign(this.formEvent, {
        id: event.id,
        task_id: event.task_id,
        activity_id: event.task?.activity.activity_id || '',
        activity_name: event?.task.activity?.activity_name || '',
        customer_per_event: event?.task?.activity?.customer_per_event || '',
        event_date: event.event_date,
        customer_id: event.customer_id,
        customer_name: event?.customer ? `${event?.customer?.first_name} ${event?.customer?.last_name}` : '',
        province_id: event.province_id,
        province_name: event?.province?.province_name || '',
        municipality_id: event.municipality_id,
        municipality_name: event?.municipality?.municipality_name || '',
        barangay_id: event.barangay_id,
        barangay_name: event?.barangay?.barangay_name || '',
        customer_attended: event.customer_attended,
        customer_bought: event.customer_bought,
        customer_bookings: event.customer_bookings,
        conversion_rate: event.conversion_rate,
        actual_hectares: event.actual_hectares,
        actual_costs: event.actual_costs,
        actual_sales: event.actual_sales,
        booking_sales: event.booking_sales,
        remarks: event.remarks,
        attachment_path: event.attachment_path,
        attachments: event.attachments || [],
        products: event?.purchases || [],
        geolocation: event?.geolocation || {
          longitude: 0,
          latitude: 0
        },
        active: event.active
      })

      if (goToAttachments) {
        this.state.modalEventTab = 1
      } else {
        this.state.modalEventTab = 0
      }

      this.$refs.modalCreateEvent.show()
    },

    eventModalHidden () {
      this.detachArrowScroller('.nav-event-tabs')
    },

    eventModalShown () {
      this.attachArrowScroller('.nav-event-tabs')

      const mapLibre = document.getElementById('mapLibre')
      if (mapLibre) {
        this.initMapLibre()
      }
    },

    initMapLibre () {
      const map = new Map({
        container: 'mapLibre',
        style: `${process.env.VUE_APP_MAP_TILER_STYLE}?key=${process.env.VUE_APP_MAP_TILER_KEY}`,
        center: [121.5886181, 16.6965175], // Aljay
        zoom: 17,
        maxZoom: 18,
        minZoom: 17,
        interactive: true,
        doubleClickZoom: false,
        maxBounds: [
          [116.0, 5], // Southwest coordinates
          [127.0, 21.5] // Northeast coordinates
        ]
      })

      const marker = new Marker()

      map.on('dblclick', () => {
        map.flyTo({
          duration: 1.25,
          easing (t) {
            return t * t * t
          },
          curve: 1,
          // offset: [0, 0],
          animate: true,
          essential: true,
          center: [
            marker.getLngLat().lng,
            marker.getLngLat().lat
          ],
          zoom: 17
        })
      })

      map.on('load', () => {
        if (this.formEvent.geolocation) {
          const { longitude, latitude } = this.formEvent.geolocation

          const userCoords = [
            longitude,
            latitude
          ]

          if (longitude !== 0 && latitude !== 0) {
            map.flyTo({
              duration: 2.25,
              easing: t => t * t * t,
              // offset: [0, 0],
              animate: true,
              essential: true,
              center: userCoords
            })

            marker.setLngLat([
              longitude,
              latitude
            ]).addTo(map)
          }
        }
      })
    }
  }
}
</script>
